export const PARTNER_DETTAGLI = {
  "fca-fiat-chrysler-automobiles": {
    nome: "FCA | Fiat Chrysler Automobiles",
    categoria: "Auto, Mobilità e Trasporti",
    categoriaSlug: "auto-mobilita",
    inPrimoPiano: true,
    image: "/logo-fca-partner.png",
    logoBg: "#ffffff",
    scontoLabel: "Offerta Esclusiva",
    scontoBadge: "Condizioni commerciali riservate agli associati Confcommercio per l'acquisto di veicoli nuovi Fiat, Lancia, Abarth, Alfa Romeo, Jeep e Fiat Professional",
    heroPhoto: "https://images.unsplash.com/photo-1617655475920-9201a2e3ea84?w=1920&q=80",
    ambientPhoto: "https://images.pexels.com/photos/164634/pexels-photo-164634.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80",
    tagline: "Speciali condizioni commerciali per l'acquisto di autoveicoli nuovi",
    descrizione: "FCA Italy S.p.A., allo scopo di offrire un trattamento di miglior favore alle aziende associate a CONFCOMMERCIO, ha predisposto speciali condizioni commerciali, valide per l'acquisto di autoveicoli nuovi dei marchi Fiat, Lancia, Abarth, Alfa Romeo, Jeep e Fiat Professional.",
    dettaglio: "Le percentuali di sconto sono valide per i veicoli ordinati presso la rete Concessionaria Italiana dei brand Fiat, Abarth, Lancia, Alfa Romeo, Jeep e Fiat Professional, solo per i possessori di Partita IVA.",
    condizioni: [
      "I trattamenti di sconto indicati nell'allegato s'intendono praticati sul listino detassato comprensivo di eventuali optional e non sono cumulabili con altre iniziative promozionali.",
      "Il trattamento di sconto si riferisce esclusivamente ai veicoli sopraelencati compresi nei vigenti listini nelle versioni attualmente commercializzate.",
      "Le vetture dovranno essere intestate direttamente alle Aziende associate a Confcommercio.",
      "Le modalità del pagamento sono da concordarsi con l'Ente venditore.",
    ],
    come: "L'Azienda associata a Confcommercio, per poter usufruire delle speciali condizioni di trattamento dovrà, all'atto della prenotazione del veicolo (firma contratto), consegnare lettera in originale dell'Associazione comprovante lo status associativo o copia della tessera di iscrizione con validità per l'anno in corso.",
    pdf: "https://www.confcommercioroma.it/wp-content/uploads/2022/10/CONVENZIONE-AUTOMOTIVE.pdf",
    contatti: "associati@confcommercioroma.it",
    telefonoConfcom: "06.68437500",
  },

  "ntm-nuovo-trasporto-merci-spedizione-trasporti-e-logistica": {
    nome: "NTM Nuovo Trasporto Merci – Spedizione, Trasporti e Logistica",
    categoria: "Auto, Mobilità e Trasporti",
    categoriaSlug: "auto-mobilita",
    image: "/logo-ntm.png",
    logoBg: "#ffffff",
    scontoLabel: "Fino al 70%",
    scontoBadge: "Risparmia fino al 70% sulle spedizioni. Scontistica dedicata dal 3% al 10% per gli associati Confcommercio Roma",
    heroPhoto: "https://images.unsplash.com/photo-1685119166946-d4050647b0e3?w=1920&q=80",
    ambientPhoto: "https://images.pexels.com/photos/4440800/pexels-photo-4440800.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80",
    tagline: "Servizi con un rapporto qualità-prezzo insuperabile",
    descrizione: "La NTM Nuovo Trasporto Merci, società giovane e dinamica, concentra il proprio focus nell'assistenza al cliente e il problem solving. Crediamo che la chiarezza nella risposta e la capacità di trovare soluzioni ad ogni richiesta, sia il valore aggiunto che ci differenzia. Dopo oltre dieci anni di attività nel settore il fondatore della NTM ha deciso di presentare al mercato una realtà di servizi dinamica e in grado di costruire offerte e proposte idonee ad ogni attività. La squadra è composta da operatori e responsabili altamente specializzati con competenze operative e tecniche acquisite sul campo e negli anni di attività.",
    servizi: [
      {
        titolo: "Spedizione Internazionale Aerea",
        desc: "Servizio di spedizione per buste, plichi e colli in 24/48 h per le maggiori località del mondo. La spedizione potrà essere seguita con il servizio di tracciatura, con possibilità di inserire consegne entro determinate fasce orarie.",
      },
      {
        titolo: "Espresso Nazionale",
        desc: "Spedizione di buste, plichi o colli in Italia con consegna in 24 h (salvo Sicilia, Calabria e Sardegna in 48 h). È possibile monitorare la spedizione tramite il servizio di tracciatura. Le spedizioni sono assicurabili.",
      },
      {
        titolo: "Servizio Economy Internazionale",
        desc: "Possibilità di spedire in tutto il mondo con servizi di consegna da 2 a 5 giorni. Raggiungiamo oltre 220 paesi. Le spedizioni sono monitorabili tramite servizio di tracciatura.",
      },
      {
        titolo: "Consegna Roma Città",
        desc: "Solo per Roma città è possibile effettuare il servizio di consegna di buste, plichi o colli con una tempistica di 24/48 h dal lunedì al venerdì, servizio svolto con mezzi NTM.",
      },
    ],
    highlights: [
      { valore: "Fino al 70%", label: "di risparmio sulle spedizioni" },
      { valore: "220+", label: "paesi raggiunti nel mondo" },
      { valore: "H24", label: "servizio clienti dedicato" },
      { valore: "3-10%", label: "sconto riservato agli associati" },
    ],
    come: "Per usufruire della Convenzione, è necessario contattare il fornitore e allegare alla richiesta di informazioni copia della tessera associativa valida per l'anno corrente.",
    contatti: "Pierluigi Iacobelli – Dir. Commerciale: cell 328.236.6844 | commerciale@nuovotrasportomerci.it",
    telefonoConfcom: "06.68437500 / 775",
    emailConfcom: "associati@confcommercioroma.it",
    pdf: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/volantino-NTM-2-scaled.jpg",
  },

  "peugeot": {
    nome: "Peugeot",
    categoria: "Auto, Mobilità e Trasporti",
    categoriaSlug: "auto-mobilita",
    image: "/logo-peugeot.png",
    logoBg: "#ffffff",
    scontoLabel: "Fino al 30%",
    scontoBadge: "Sconti fino al 30% su tante vetture e veicoli commerciali Peugeot per tutti gli associati Confcommercio Roma",
    heroPhoto: "https://images.pexels.com/photos/164634/pexels-photo-164634.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80",
    ambientPhoto: "https://images.unsplash.com/photo-1560207404-825ba81b6884?w=1920&q=80",
    tagline: "Devi acquistare un'auto o un veicolo commerciale?",
    descrizione: "Grazie all'accordo Confcommercio – Peugeot gli Associati possono usufruire di speciali condizioni per soddisfare tutte le esigenze di mobilità. Presente in quasi 160 paesi con più di 10.000 punti di contatto, Peugeot associa in tutto il mondo Esigenza, Fascino ed Emozione. L'alto livello qualitativo dei prodotti e servizi rivolto ai professionisti, la raffinatezza del design, la cura per i dettagli e l'esperienza di guida, contribuiscono all'emozione offerta da ogni mezzo.",
    vantaggi: [
      "Sconti fino al 30% su tante vetture e i veicoli commerciali",
      "Condizioni riservate su tutta la gamma Peugeot, dai veicoli city car ai SUV",
      "Offerte dedicate anche sui veicoli elettrici e ibridi plug-in",
      "Assistenza personalizzata presso i concessionari convenzionati",
    ],
    concessionari: [
      { nome: "Peugeot Stellantis &You Roma", indirizzo: "Viale Manzoni, 67, 00185 Roma RM" },
      { nome: "Peugeot Stellantis &You Roma", indirizzo: "Via Tiburtina, 1144, 00156 Roma RM" },
      { nome: "Peugeot – Kia – Milli 2", indirizzo: "Via Santa Monica, 6, 00122 Lido di Ostia RM" },
    ],
    come: "Presentare la tessera associativa Confcommercio Roma in corso di validità presso uno dei concessionari Peugeot convenzionati. Il personale di vendita provvederà ad applicare le condizioni riservate agli associati.",
    contatti: "associati@confcommercioroma.it",
    telefonoConfcom: "06.68437500",
  },

  "saba-parcheggi-parcheggio-di-villa-borghese": {
    nome: "SABA PARCHEGGI | Parcheggio Roma Villa Borghese",
    categoria: "Auto, Mobilità e Trasporti",
    categoriaSlug: "auto-mobilita",
    inPrimoPiano: true,
    image: "/logo-saba.jpeg",
    logoBg: "#ffffff",
    scontoLabel: "20-30%",
    scontoBadge: "Abbonamenti mensili scontati tra il 20% e il 30% rispetto al prezzo di listino, estesi a titolari, soci e dipendenti",
    heroPhoto: "https://images.pexels.com/photos/28003818/pexels-photo-28003818.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80",
    ambientPhoto: "https://images.unsplash.com/photo-1533240823717-891464c064af?w=1920&q=80",
    tagline: "Il Parcheggio SABA, con 1800 posti auto nel cuore di Roma, è la soluzione che stai cercando.",
    descrizione: "Rinunci ad andare in centro per il problema del parcheggio? Il Parcheggio SABA di Villa Borghese è collegato attraverso percorsi pedonali a Piazza di Spagna, Via del Babuino e Via Vittorio Veneto e si trova nelle vicinanze delle principali attrazioni della città e delle vie dello shopping. La struttura è facilmente accessibile in auto e ben collegata con i mezzi pubblici.\n\nSABA Italia S.p.A. riserva a tutti gli associati Confcommercio Roma condizioni agevolate per la sosta in abbonamento mensile. Le agevolazioni sono estese ai titolari, soci e dipendenti delle aziende associate.",
    abbonamenti: [
      { tipo: "Auto Mensile", orari: "Lunedì / Domenica dalle ore 7.00 alle ore 21.00" },
      { tipo: "Auto Mensile H24", orari: "7 giorni su 7, 24 ore su 24" },
      { tipo: "Moto Mensile H24", orari: "7 giorni su 7, 24 ore su 24" },
    ],
    come: "Inviare mail a marco.ciuffetelli@sabagroup.com indicando: la ragione sociale dell'esercizio commerciale, copia o numero della tessera associativa Confcommercio Roma, il tipo di abbonamento di cui si vuole usufruire. In alternativa, recarsi direttamente al parcheggio esibendo copia della tessera associativa valida per l'anno corrente.",
    indirizzo: "Via del Galappatoio, 33 – 00197 Roma",
    emailPartner: "marco.ciuffetelli@sabagroup.com",
    sitoWeb: "https://www.sabait.it/it/parcheggio-roma/parcheggio-saba-villa-borghese",
    contatti: "Confcommercio Roma: 06.68437630 – 06.68437271 | info@confcommercioroma.it",
    telefonoConfcom: "06.68437630",
    emailConfcom: "info@confcommercioroma.it",
  },

  "generali-italia-assicurazioni": {
    nome: "Generali Italia | Assicurazioni",
    categoria: "Banche e Assicurazioni",
    categoriaSlug: "banche-assicurazioni",
    inPrimoPiano: true,
    image: "/logo-generali.webp",
    logoBg: "#ffffff",
    scontoLabel: "20-35%",
    scontoBadge: "Sconti dal 20% al 35% sui principali prodotti assicurativi",
    descrizione: "Generali Italia è leader nel mercato assicurativo italiano retail e tra gli assicuratori più importanti al mondo. Con 11 milioni di clienti, è il primo assicuratore in Italia.",
    dettaglio: "Attraverso la collaborazione con Confcommercio, offre agli Associati soluzioni personalizzate con sconti dal 20% al 35% sui principali prodotti assicurativi per proteggere i propri progetti imprenditoriali e personali.",
    prodotti: [
      { nome: "ATTIVA COMMERCIO", desc: "Protezione dell'attività: incendio, scoppio, esplosione, acqua condotta, rischio informatico." },
      { nome: "ATTIVA TURISMO", desc: "Soluzione per strutture ricettive alberghiere ed extralberghiere, modulare e personalizzabile." },
      { nome: "ATTIVA ARTI & MESTIERI", desc: "Dedicata alle attività artigiane e manifatturiere." },
      { nome: "IMMAGINA ADESSO SALUTE", desc: "Polizza dedicata alla salute con Assistenza EuropAssistance in tutto il mondo." },
      { nome: "IMMAGINA ADESSO CASA", desc: "Assicurazione casa: di proprietà, in affitto, al mare o in città." },
    ],
    contatti: "Telefono e WhatsApp: 347 3096153 | Email: info@generalinavigatori.it",
    sconto: "dal 20% al 35%",
  },
  "dolomiti-energia": {
    nome: "Dolomiti Energia",
    categoria: "Energy e Utilities",
    categoriaSlug: "energy-utilities",
    image: "/logo-dolomiti.webp",
    logoBg: "#ffffff",
    scontoLabel: "Risparmio",
    scontoBadge: "Condizioni competitive su energia elettrica e gas",
    descrizione: "Dolomiti Energia, ai vertici della classifica nazionale di Altroconsumo per la qualità dei servizi, fa parte dell'omonimo Gruppo con importante capacità produttiva di energia da fonte rinnovabile grazie alle centrali idroelettriche sulle Dolomiti.",
    dettaglio: "Confcommercio, insieme a Dolomiti Energia, offre ai propri Associati e loro Dipendenti condizioni di mercato particolarmente competitive sulla fornitura di energia elettrica e gas.",
    vantaggi: [
      "Analisi delle bollette di luce e gas e preventivo di spesa gratuito",
      "Fornitura di energia elettrica alle migliori condizioni di mercato, 100% rinnovabile",
      "Innovativa formula Gas 100% Compensa CO2",
      "Servizi di green marketing per comunicare la vocazione green",
      "Servizi di efficienza energetica: relamping, power quality, progetti chiavi in mano",
    ],
    pdf: "https://www.confcommercioroma.it/wp-content/uploads/2022/08/DOLOMITI-FLYER.pdf",
  },
};
